import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";
import "./i18n/i18n";
import "./index.css";

import App from "./App";

const rootElement = document.getElementById("root");

if (!rootElement) {
    throw new Error(
        "L’élément #root est introuvable dans index.html.",
    );
}

const root = createRoot(rootElement);

root.render(
    <StrictMode>
        <App />
    </StrictMode>,
);